import { CubeDimension, DimHierarchyData, DimHierarchyLevelData, CubeMeasure, MeasureData } from './service';
import { Component, Input, Output, EventEmitter } from "@angular/core";
// import { NumberUtils } from './../../common/service/number.utils';

@Component({
    selector: 'dataPreview',
    templateUrl: 'dataPreview.html',
    styleUrls: ['../../biAdminStyles.css']
})

export class DataPreview {
    
    @Input() previewAnalyticalModel: any = {};
    @Input() tntConfData: any = {};
    @Output() pageDetailsSender= new EventEmitter();
    @Output() loadPreviewSender= new EventEmitter();

    public loader: boolean = false;
    public pageDetails : any;
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public endingPage: number = 10;
    public currentPage: number = 1;
    public total: number = 0;
    public decFormat: number;
    public numFormat: any;


    // constructor() { }

    ngOnChanges() {
        if (this.previewAnalyticalModel && this.previewAnalyticalModel != 'error') {
            this.setPagination();
            // this.setConfigs();
            // this.setValue();
            this.loader = false;
        } else if (this.previewAnalyticalModel == 'error') {
            this.loader = false;
        } else {
            this.loader = true;
            this.loadPreviewSender.emit(true);
        }
    }

    setConfigs(){
        if(!this.tntConfData) return;
        this.tntConfData.tenantConfigDataList.forEach((conf)=>{
            if(conf.key == 'NUMBER_FORMAT'){
                this.numFormat = conf.value;
                return;
            }
        });
        this.decFormat = this.numFormat.length - this.numFormat.indexOf(".") - 1;
    }

    setValue(){
        let self = this;
        self.previewAnalyticalModel.rows.forEach((row,i)=>{
            let rowData=[];
            row.forEach((val) => {
                let numVal:any = Number(val);
                if (!Number.isNaN(numVal) && numVal != 0) {
                    val = numVal.toFixed(this.decFormat).toString();
                    numVal = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                    numVal = numVal.toString().split(".");
                    numVal = Number(numVal[1]) != 0 ? numVal.join(".") : numVal[0];
                    rowData.push(numVal);
                } else {
                    rowData.push(val);
                }
            });
            self.previewAnalyticalModel.rows[i] = rowData;
        });
    }

    setPagination(){
        this.total = this.previewAnalyticalModel.total;
        this.currentPage = this.previewAnalyticalModel.page + 1;
        this.pageSize = this.previewAnalyticalModel.size;
        this.startingPage = Math.floor(this.pageSize * (this.currentPage - 1));
        this.endingPage = this.startingPage + this.pageSize;
        (this.endingPage > this.total) ? this.endingPage = this.total : null;
    }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.total / this.pageSize);
        if (maxPage < this.pageNo) {
            this.pageNo = maxPage;
        }
        this.setPageDetails();
        this.loader = true;
        this.previewAnalyticalModel = null;
        this.pageDetailsSender.emit(this.pageDetails);
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.setPageDetails();
        this.loader = true;
        this.previewAnalyticalModel = null;
        this.pageDetailsSender.emit(this.pageDetails);    }

    setPageDetails() {
        this.pageDetails = {
            pageNo: this.pageNo, pageSize: this.pageSize,
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/dataPreview.ts